<template>
    <div class="container-fluid full-height">
        <div class="row">
            <div class="col-12 col-no-padding">
                <form class="form">
                    <div class="form-row row">
                        <label class="col-12">{{ $t('plans.form.label') }}</label>
                        <input ref="label" type="text" v-model="label" class="form-input col-12"/>
                    </div>
                </form>
            </div>
        </div>
        <Toolbar class="not-fixed">
            <Btn class="primary" @click.native.stop="valid">
                {{ $t('global.save') }}
            </Btn>
            <Btn @click.native.stop="cancel">
                {{ $t('global.cancel') }}
            </Btn>
        </Toolbar>
    </div>

</template>

<script>
    import Toolbar from '@/components/ui/Toolbar';
    import AddressField from '@/components/ui/fields/AddressField';
    import Btn from "@/components/ui/Button";
    import MiniMap from '@/components/plans/map/MiniMap';

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Toolbar,
            Btn,
            MiniMap

        },
        computed: {},
        created: function () {

        },
        data () {
            return {
                label: '',
                obj: null,
                editMode: false
            }
        },
        destroyed: function () {

        },
        methods: {
            resetForm: function(){
                this.label = '';
            },
            cancel: function(){
                this.resetForm();
                this.$emit('close','add','floor');
            },
            valid: function(){
                if(this.editMode){
                    this.obj.name = this.label;
                    this.$emit('editFloor',this.obj);
                }
                else {
                    var obj = {
                        type: 5,
                        name: this.label
                    }

                    this.$emit('addFloor', obj);
                }
                //this.resetForm();
            },
            edit: function(edit,obj){
                if(edit == null){
                    edit = false;
                }
                this.editMode = edit;
                if(obj != null) {
                    this.obj = obj;
                    this.label = obj.name;
                }
                if(!edit){
                    this.$refs.label.focus();
                }
            }
        },
        mounted: function () {

        },
        name: '',
        props: ['parent'],
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>